import $ from 'jquery'
import Splide from "@splidejs/splide";


const initializeBlock = function ($block) {
    var blockID = $block.attr('data-unique-id')
    var breakpoint = 992;

    var splide = new Splide('.js-vehicles-' + blockID, {
        type: 'loop',
        perPage: 2,
        perMove: 1,
        pagination: false,
    });
    splide.mount();

    function toggleSplide() {
        if (splide) {
            if ( window.innerWidth > breakpoint ) {
                splide.mount();
            } else {
                splide.destroy();
            }
        }
    }

    window.addEventListener('resize', toggleSplide);
    toggleSplide();
}


$('.vehicle-range-block').each(function () {
    initializeBlock($(this))
})

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=autostrategy-vehicle-range',
        initializeBlock
    )
}
